<template>
  <div>
    <h2 class="text-h5 font-weight-bold mt-4 mb-2">{{ title }}</h2>
    <transition-group name="slide-x-transition">
      <InvoiceItem v-for="li of items" :key="li.id" :line-item="li" />
    </transition-group>
  </div>
</template>

<script>
import InvoiceItem from '@/components/InvoiceItem'

export default {
  props: {
    title: {
      type: String,
      default: 'Items',
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  name: 'InvoiceItemsSection',
  components: {
    InvoiceItem,
  },
  data() {
    return {}
  },
}
</script>
